import {ContentHotel} from '@findhotel/sapi/dist/types/packages/core/src/types'

export enum PolicySubSection {
  CheckInInstructions = 'CheckInInstructions',
  SecurityDeposit = 'SecurityDesposit',
  GoodToKnow = 'GoodToKnow',
  OptionalFees = 'OptionalFees'
}

export type ContentKey = keyof ContentHotel
